<template>
  <div class="administratorsList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="value">
            <el-option key :label="$t('lang.villageall')" value></el-option>
            <el-option
              v-for="(item,index) in villageList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="input" :placeholder="$t('lang.accountOrname')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="jump">{{$t('lang.addadministratorsBtn')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.administratorsListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="id" :label="$t('lang.lab_userid')" width="100px"></el-table-column>
        <el-table-column prop="userName" :label="$t('lang.lab_account')" width="150px"></el-table-column>
        <el-table-column prop="nickName" :label="$t('lang.lab_name')"></el-table-column>
        <el-table-column prop="ownerGardens" sortable :label="$t('lang.lab_garden')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.ownerGardens&&scope.row.ownerGardens.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span v-for="(i,index) in scope.row.ownerGardensTip" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>
                {{ scope.row.ownerGardens.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.ownerGardens.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div slot="content">
                <span v-for="(i,index) in scope.row.ownerGardensTip" :key="index">
                  {{ i }};
                  <br />
                  <br />
                </span>
              </div>
              <div>{{ scope.row.ownerGardens | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="supportCount" :label="$t('lang.lab_workstatus')" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.isLeave === 0">在职</span>
            <span v-else>离职</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width3"
        >
          <template slot-scope="scope">
			
			<el-button v-if="scope.row.isLeave!=0" @click="handleInduction(scope.row.id)">恢复入职</el-button>
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:administratorsList
 *@Description:管理员列表
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-02-19
 */
export default {
  name:'/manage/main.adminList',
  data() {
    return {
      input: '', // 关键字
      value: '', // 小区绑定值
      pageCount: 0, // 总页数
      pageNum: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      villageList: [], // 小区下拉列表
      administratorsListcheckbox: require('@/config/enum')
        .administratorsListcheckbox // 是否隐藏复选框
    }
  },
  created() {
    setTimeout(() => {
      window.localStorage.setItem('glyform', '')
      window.localStorage.setItem('glystaffGardenList', '')
      window.localStorage.setItem('glysaveData', '')
      window.localStorage.setItem('glycheckedrole', '')
      window.localStorage.setItem('glymunelist', '')
    }, 200)
    this.adminslist()
    this.gardens()
  },
  activated(){
    this.adminslist()
    this.gardens()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 小区下拉
    gardens() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.villageList = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 管理员列表
    adminslist() {
      let loading = this.$loading()
      this.$get(
        `/admins?garden=${this.value}&pageSize=${this.pageSize}&pageNo=${this.pageNum}&keyword=${this.input.trim()}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].ownerGardens) {
                this.tableData[i].ownerGardensTip = this.tableData[i].ownerGardens.split(',')
              }
            }
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.adminslist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.adminslist()
    },
    edit(id) {
      window.localStorage.setItem('glyform', '')
      window.localStorage.setItem('glystaffGardenList', '')
      window.localStorage.setItem('glysaveData', '')
      window.localStorage.setItem('glycheckedrole', '')
      window.localStorage.setItem('glymunelist', '')
      this.$router.push({ name: 'addAdminStrators', query: { id: id } })
    },
    jump() {
      window.localStorage.setItem('glyform', '')
      window.localStorage.setItem('glystaffGardenList', '')
      window.localStorage.setItem('glysaveData', '')
      window.localStorage.setItem('glycheckedrole', '')
      window.localStorage.setItem('glymunelist', '')
      this.$router.push({ name: 'addAdminStrators' })
    },
    commit() {
      this.pageNum = 1
      this.adminslist()
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`/admins/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
	// 处理恢复入职
	handleInduction(id) {
	    this.$confirm('确认要恢复该员工为在职状态吗?', '提示', {
		  confirmButtonText: '确定',
	      cancelButtonText: '取消',
	      type: 'warning'
	    }).then(() => {
	      this.induction(id)
	    }).catch(() => {
	      this.$message({
	        type: 'info',
	        message: '已取消操作'
	      })
	    })
	},
	//恢复入职
	induction(id){
		this.$post(`/returnIsLeavestaffs/`+id).then(
		  res => {
		    console.log(res)
		    if (res && res.errCode === 0) {
		      this.$message({
		        type: 'success',
		        message: '恢复入职成功'
		      })
		      this.commit()
		    }else{
		    	this.$message.error(res.errMsg)
		    }
		  },
		  error => {
		    this.$message.error(error)
		  }
		)
	}
  }
}
</script>

<style lang="scss">
</style>